/** @link https://webpack.js.org/guides/public-path/ */
/* eslint-disable */
__webpack_public_path__ = model.topology.cdn + '/';
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/client/js/system/topology.js